import { displayBillingAddressesModal } from "../checkout/billingCT";
import { loadNewStoreModal, retryOrderSubmit } from "../checkout/shippingCT";
import { initTooltip } from "./toolTip";
import { inputAnimationEvents } from "./formElementsUtil";
import { removeAddressModalEvents } from "../addressBook/addressUtil";
import { confirmCardRemovalEvents } from "../paymentInstruments/paymentInstrumentsUtil";
import { consentConfirmationBtnClickEvent, consentTermsAndConditionsInputEvent, updateCartSummaryModalClass } from "./cartUtil";
import { initEvents } from "../utilities/globalEvents";
import { loadLazyImages } from "../utilities/globalUtilities";
import { SiteCredentials } from "@sonaemc-digital/continente-credentials-web-sdk";
import { showInApp, handleDismissInApp } from "./inAppsUtil";

const $cache = {
    body: $("body"),
    document: $(document)
};
const scrollLock = require("../utilities/scrollLock");
let breakpoints = require("../utilities/breakpoints");

let siteCredentials;

/*
** @description: Function that will toggle the svg arrows visibility depending on the dropdown state : open/closed
** @param: N/A
*/
const modalToggleArrow = () => {
    var $modalArrow = $(".js-modal-toggle-arrow");
    var $modalTitle = $(".ct-modal-toggle-title");

    if ($modalArrow.length > 0 && $modalTitle.length > 0) {
        $modalArrow.add($modalTitle).on("click", e => {
            e.preventDefault();
            $(e.target).closest(".js-colapse-data").find(".js-modal-toggle-arrow").toggleClass("d-none");
        });
    }
};

/**
 * @function
 * @description - Handle body no-scroll and modal-open classes, when the modals are opened/closed
 */
const handleBodyScroll = () => {
    $(".modal").on("shown.bs.modal", e => {
        $cache.body.addClass("modal-open");
        scrollLock.enable();

        //GTM logic - Start
        const $this = $(e.currentTarget);
        const $gtmMessageContainer = $this.find(".gtm-message");

        if (!$gtmMessageContainer.length) {
            return;
        }

        if ($gtmMessageContainer.hasClass("gtm-message-pushed")) {
            return;
        }

        const $innerContentAsset = $gtmMessageContainer.siblings(".content-asset");

        document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
            detail: {
                "success": $gtmMessageContainer.hasClass("gtm-message--success") ? true : false,
                "messageContent": $innerContentAsset.length ? $innerContentAsset.text() : $gtmMessageContainer.text(),
            }
        }));

        //GTM logic - End
    });

    $(".modal").on("hidden.bs.modal", e => {
        if ($cache.body.hasClass("navigation-open") || $(".modal.show").length > 0) {
            $cache.body.addClass("modal-open");
            scrollLock.enable();
        } else {
            scrollLock.disable();
            updateCartSummaryModalClass(false);
        }

        //GTM logic - Start
        const $this = $(e.currentTarget);
        const $gtmMessageContainer = $this.find(".gtm-message");

        if ($gtmMessageContainer.length > 0) {
            $gtmMessageContainer.removeClass("gtm-message-pushed");
        }
        //GTM logic - End
        if ($this.length > 0 && $this[0].id == "session-lost-login-modal") {
            const homePageUrl = window.sessionStorage.getItem("homePageUrl");

            if (homePageUrl) {
                window.location.href = homePageUrl;
            } else {
                const redirectURL = $(".js-login-lost-session").attr("data-url");
                window.location.href = redirectURL;
            }
        }
    });


    $(".modal-credential").on("hidden.bs.modal", e => {
        const modal = e.currentTarget;
        siteCredentials.close();
        siteCredentials = null;

        const updateCustomerDataUrl = modal.getAttribute("data-update-customer-url");
        const credentialsPageModal = modal.getAttribute("data-credentials-page");

        $.spinner().start();

        $.ajax({
            url: updateCustomerDataUrl,
            type: "GET",
            success: function (response) {
                if (credentialsPageModal == "credentials-page-personal-account" && response.changedProfile) {
                    window.location.reload();
                } else if ((credentialsPageModal == "credentials-page-add-continente-card" || credentialsPageModal == "credentials-page-remove-continente-card") && response.changedContinenteCard) {
                    window.location.reload();
                }
                $.spinner().stop();
            }
        });
    });
};

/**
 * @function
 * @description - Return HTML of the requested template after call to 'Page-RenderTemplate' endpoint
 * @param {Object} modal - Triggered modal container
 */
const getModalOnDemand = modal => {
    const $modal = $(modal);
    const $modalBody = $modal.find(".js-modal-body");
    const url = $(".js-mod-url").data("url");
    const templatePath = $modal.data("mod-template-path");
    const cached = $modal.data("mod-cached");
    const cachePersonalized = $modal.data("mod-cache-personalized");
    const params = $modal.data("params") || {};
    const afterInjectBody = $modal.data("after-inject-body");

    $.spinner().start();

    if (!templatePath) { return; }

    return $.ajax({
        url: url,
        method: "GET",
        data: {
            ...params,
            template: templatePath,
            cached: !!cached,
            cachePersonalized: cachePersonalized ? cachePersonalized : undefined
        },
        success: data => {
            $modalBody.html(data);
            typeof afterInjectBody === "function" && afterInjectBody($modalBody);

            if (modal.id == "session-lost-login-modal") {
                const $modalBodyContent = $modal.find(".modal-body.js-modal-body");

                if ($modalBodyContent.length > 0) {
                    $modalBodyContent.removeClass("modal-body js-modal-body");
                }
            }

            $.spinner().stop();
            loadLazyImages(`#${modal.id}`);
            
            //GTM logic - Start
            const $this = $modal;
            const $gtmMessageContainer = $this.find(".gtm-message");

            if (!$gtmMessageContainer.length) {
                return;
            }
            $gtmMessageContainer.addClass("gtm-message-pushed");

            const $innerContentAsset = $gtmMessageContainer.siblings(".content-asset");
            document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
                detail: {
                    "success": $gtmMessageContainer.hasClass("gtm-message--success") ? true : false,
                    "messageContent": $innerContentAsset.length ? $innerContentAsset.text() : $gtmMessageContainer.text(),
                }
            }));
            //GTM logic - End
        },
        error: () => {
            $.spinner().stop();
        }
    });
};

/**
 * @function
 * @description - Contains modal show events that calls the endpoint and populate the modal with its content
 */
const initOnShow = () => {

    $(".modal-on-demand:not(.complex-modal)").off("show.bs.modal").on("show.bs.modal", e => {
        const modal = e.currentTarget;
        const $modal = $(modal);
        const alwaysFetchBody = $modal.data("mod-always-fetch-body");

        if (modal.querySelector(".js-modal-body").hasChildNodes() && !alwaysFetchBody) {
            //GTM logic - Start
            const $this = $(e.currentTarget);
            const $gtmMessageContainer = $this.find(".gtm-message");

            if (!$gtmMessageContainer.length) {
                return;
            }
            $gtmMessageContainer.addClass("gtm-message-pushed");
            const $innerContentAsset = $gtmMessageContainer.siblings(".content-asset");
            document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
                detail: {
                    "success": $gtmMessageContainer.hasClass("gtm-message--success") ? true : false,
                    "messageContent": $innerContentAsset.length ? $innerContentAsset.text() : $gtmMessageContainer.text(),
                }
            }));
            //GTM logic - End

            return;
        }

        $.when(getModalOnDemand(modal)).fail(error => {
            handleModalFail(error, modal);
        });
    });

    $("#shipping-new-address-modal").off("show.bs.modal").on("show.bs.modal", _e => {
        updateCartSummaryModalClass(true);
    });

    $("#billing-addresses-area-modal").off("show.bs.modal").on("show.bs.modal", e => {
        const modal = e.currentTarget;

        if (modal.querySelector(".js-modal-body").hasChildNodes()) { return; }

        $.when(getModalOnDemand(modal)).done(() => {
            displayBillingAddressesModal();
        }).fail(error => {
            handleModalFail(error, modal);
        });
    });

    $("#shipping-new-store-modal").off("show.bs.modal").on("show.bs.modal", e => {
        updateCartSummaryModalClass(true);

        const modal = e.currentTarget;
        let modalBody = modal.querySelector(".js-modal-body");

        if (modalBody.hasChildNodes()) {
            modalBody.innerHTML = "";
        }

        $.when(getModalOnDemand(modal)).done(() => {
            loadNewStoreModal();
        }).fail(error => {
            handleModalFail(error, modal);
        });
    });

    $("#add-cartao-da-card-continente-pay").off("show.bs.modal").on("show.bs.modal", e => {
        updateCartSummaryModalClass(true);
        const modal = e.currentTarget;

        if (modal.querySelector(".js-modal-body").hasChildNodes()) { return; }

        $.when(getModalOnDemand(modal)).done(() => {
            $cache.document.trigger("initFormValidation");
            inputAnimationEvents();
            initTooltip();
            $.applyDataMask($(modal).find("[data-mask]"));
        }).fail(error => {
            handleModalFail(error, modal);
        });
    });

    $(".modal-credential").off("show.bs.modal").on("show.bs.modal", e => {
        const modal = e.currentTarget;

        const openSiteCredentialsUrl = modal.getAttribute("data-url");
        const idBodyContainer = modal.getAttribute("data-body-container");
        $.spinner().start();
        $.ajax({
            url: openSiteCredentialsUrl,
            type: "GET",
            success: function (response) {
                if (response && response.success && response.siteCredentialsToken && response.clientId) {
                    siteCredentials = new SiteCredentials(
                        "#"+idBodyContainer,
                        response.clientId,
                        response.siteCredentialsToken,
                        {
                            baseUrl: response.baseUrl
                        }
                    );
                    siteCredentials.open();
                }

                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $("#remove-address-modal").off("show.bs.modal").on("show.bs.modal", e => {
        const modal = e.currentTarget;

        if (modal.querySelector(".js-modal-body").hasChildNodes()) { return; }

        $.when(getModalOnDemand(modal)).done(() => {
            removeAddressModalEvents();
        }).fail(error => {
            handleModalFail(error, modal);
        });
    });

    $("#delete-payment-modal").off("show.bs.modal").on("show.bs.modal", e => {
        const modal = e.currentTarget;
        const triggeringBtn = e.relatedTarget;

        if (modal.querySelector(".js-modal-body").hasChildNodes()) {
            confirmCardRemovalEvents(triggeringBtn);
        } else {
            $.when(getModalOnDemand(modal)).done(() => {
                confirmCardRemovalEvents(triggeringBtn);
            }).fail(error => {
                handleModalFail(error, modal);
            });
        }
    });

    $("#consent-confirmation-modal").off("show.bs.modal").on("show.bs.modal", e => {
        const modal = e.currentTarget;

        if (modal.querySelector(".js-modal-body").hasChildNodes()) { return; }

        $.when(getModalOnDemand(modal)).done(() => {
            consentConfirmationBtnClickEvent();
            consentTermsAndConditionsInputEvent();
        }).fail(error => {
            handleModalFail(error, modal);
        });
    });

    $("#service-error-delivery-slots").off("show.bs.modal").on("show.bs.modal", e => {
        const modal = e.currentTarget;

        if (modal.querySelector(".js-modal-body").hasChildNodes()) { return; }

        $.when(getModalOnDemand(modal)).done(() => {
            initEvents();
        }).fail(error => {
            handleModalFail(error, modal);
        });
    });

    $("#service-error-order-submit").off("show.bs.modal").on("show.bs.modal", e => {
        const modal = e.currentTarget;

        if (modal.querySelector(".js-modal-body").hasChildNodes()) { return; }

        $.when(getModalOnDemand(modal)).done(() => {
            retryOrderSubmit();
        }).fail(error => {
            handleModalFail(error, modal);
        });
    });

    $("#add-to-cart-error").off("show.bs.modal").on("show.bs.modal", e => {
        const modal = e.currentTarget;

        if (modal.querySelector(".js-modal-body").hasChildNodes()) { return; }

        $.when(getModalOnDemand(modal)).done(() => {
            const $errorMessageContainer = $(modal).find(".js-add-to-cart-error-msg");
            $errorMessageContainer.text(modal.dataset.errorMsg);
            //GTM logic - Start
            document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
                detail: {
                    "success": false,
                    "messageContent": modal.dataset.errorMsg
                }
            }));
            //GTM logic - End
        }).fail(error => {
            handleModalFail(error, modal);
        });
    });
    if ($("#homepage-value-proposal-modal").length > 0) {
        $("#homepage-value-proposal-modal").modal("show");

        $("#homepage-value-proposal-modal .pwc-content-slot-modal-btn").on("click", function () {
            var rurl = $(this).data("redirect-url");

            if (rurl) {
                window.location.href = rurl;
            }
        });
    }

    var $inAppsModal = $(".js-in-apps-modal");
    var $continueBtn = $(".js-continue-button-in-app");
    var $dismissInApp = $(".js-dismiss-in-app");

    if ($inAppsModal.length > 0 && showInApp($inAppsModal)) {
        if ($continueBtn.length > 0) {
            $continueBtn.on("click", function () {
                if ($dismissInApp.length > 0 && $dismissInApp[0].checked) {
                    handleDismissInApp($(this));
                }

                var rurl = $(this).data("redirect-url");
                if (rurl) {
                    window.location.href = rurl;
                }
            });
        }

        $inAppsModal.modal("show");
    }

    $("#product-note-modal").off("show.bs.modal").on("show.bs.modal", e => {
        const modal = e.currentTarget;
        var productID = modal.dataset.productId;

        $.when(getModalOnDemand(modal)).done(() => {
            //modal opened
            const submitButton = modal.querySelector(".js-add-note-button");
            const noteLabel = modal.querySelector(".add-product-note-label");
            const modalNoteInput = modal.querySelector(".add-product-note");
            const modalProductID = modal.querySelector("#modal-product-id");
            const modalSavedNote = modal.getAttribute("data-saved-note");
            const notePreview = document.querySelector(`.note-preview-section[data-pid='${productID}']`);

            modalProductID.value = productID;
            modalNoteInput.value = modalSavedNote;
            if (modalNoteInput.value.trim() !== "") {
                noteLabel.classList.add("d-none");
                submitButton.removeAttribute("disabled");
            }

            modalNoteInput.addEventListener("input", function () {
                if (modalNoteInput.value.trim() !== "") {
                    noteLabel.classList.add("d-none");
                } else {
                    noteLabel.classList.remove("d-none");
                }
            });

            //modal delete note Btn
            document.querySelectorAll(".js-note-reset-button-modal").forEach(element => {
                element.addEventListener("click", function () {
                    modalNoteInput.value = "";
                    notePreview.classList.add("d-none");
                    submitButton.click();
                });
            });

        }).fail(error => {
            handleModalFail(error, modal);
        });
    });

    const openModalMobile = $modal => {
        if (!$modal.hasClass("show")) {
            $(this).trigger("modalOpened");

            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            $("body").css("top", -$(window).scrollTop()).addClass("modal-open-custom undraggable").append("<div class='modal-backdrop modal-backdrop-custom fade show' id='backdrop-"+$modal.attr("id")+"'></div>");

            if (window.innerWidth > breakpoints.values.tablet) {
                $modal.addClass("fade");
                if ($(".js-header-banner").length) {
                    $(".js-header-banner").css("padding-right", scrollbarWidth+"px");
                }
                $("body").css("padding-right", scrollbarWidth+"px");
            }

            $modal.show();
            showModal($modal);
        } else {
            closeModalMobile($modal);
        }
    };

    const showModal = $modal => {
        setTimeout(() => {
            $modal.addClass("show");
            enableDragging();
        }, 50);
    };

    const enableDragging = () => {
        setTimeout(function () {
            $("body").removeClass("undraggable");
        }, 310);
    };

    const closeModalMobile = $modal => {
        $modal.removeClass("dragDown").css({"bottom": "-110vh"});
        $("#backdrop-"+$modal.attr("id")+"").fadeOut("fast");

        if (window.innerWidth > breakpoints.values.tablet) {
            $modal.removeClass("show");
        }

        setTimeout(() => {
            $modal.removeAttr("style");
            const topValue = Math.abs(parseInt($("body").css("top"), 10));
            if ($(".js-header-banner").length) {
                $(".js-header-banner").css("padding-right", "0");
            }

            if (window.innerWidth <= breakpoints.values.tablet) {
                $modal.removeClass("show");
            } else {
                $modal.removeClass("fade");
            }

            if ($("modal-mobile.show").length == 0) {
                $("body").removeClass("modal-open-custom").css({"top": "unset", "padding-right": "0"});
                $(window).scrollTop(topValue);
            }

            if ($("#backdrop-"+$modal.attr("id")+"").length)
                $("#backdrop-"+$modal.attr("id")+"").remove();
        }, 310);
    };

    $("body").on("click", ".open-modal-mobile", function () {
        if (!$(this).data("target")) return false;
        const $modal = $($(this).data("target"));
        openModalMobile($modal);
    });

    $("body").on("click", ".close-modal-mobile", function () {
        const $modal = $(this).closest(".modal-mobile");
        closeModalMobile($modal);
    });

    const $dragHandle = $(".modal-mobile .modal-content");
    let startY, deltaY, currentY, initialBottom, isDragging = false;

    $dragHandle.on("touchstart mousedown", function (e) {
        const $modal = $(e.target).closest(".modal-mobile");
        const $draggingInScroll = $(e.target).hasClass("modal-body") ? $(e.target) : $(e.target).closest(".modal-body");

        if ($("body").hasClass("undraggable") || ($draggingInScroll && $draggingInScroll.length && $draggingInScroll.hasClass("modal-body") && $draggingInScroll.scrollTop() > 0)) {
            isDragging = false;
        } else {
            isDragging = true;
            startY = e.type === "touchstart" ? e.touches[0].pageY : e.pageY; // Position of first click/touch
            initialBottom = parseInt($modal.css("bottom"), 10);
        }
    });

    $dragHandle.on("touchmove mousemove", function (e) {
        if (!isDragging) return;

        const $draggingInScroll = $(e.target).hasClass("modal-body") ? $(e.target) : $(e.target).closest(".modal-body");

        if ($draggingInScroll && $draggingInScroll.length && $draggingInScroll.hasClass("modal-body") && $draggingInScroll.scrollTop() > 0) {
            isDragging = false;
        } else {
            const $modal = $(e.target).closest(".modal-mobile");
            currentY = e.type === "touchmove" ? e.touches[0].pageY : e.pageY;
            deltaY = currentY - startY;

            if (initialBottom - deltaY < -1) {
                if (!$modal.hasClass("dragDown")) $modal.addClass("dragDown");
                $modal.css("bottom", initialBottom - deltaY + "px");
            } else {
                if ($modal.hasClass("dragDown")) $modal.removeClass("dragDown");
            }
        }
    });

    $dragHandle.on("touchend mouseup", function (e) {
        if (!isDragging) return;

        const $modal = $(e.target).closest(".modal-mobile");
        const minToAutoDragDown = 100;
        const minPercentageToAutoDragDown = 0.35;
        const limitToHide = $modal.height()*minPercentageToAutoDragDown > minToAutoDragDown ? $modal.height()*minPercentageToAutoDragDown : minToAutoDragDown;
        isDragging = false;

        if (!$(e.target).hasClass("close-modal-mobile") && $(e.target).closest(".close-modal-mobile").length == 0) {
            if (deltaY >= limitToHide) {
                closeModalMobile($modal);
            } else {
                $modal.removeClass("dragDown").css("bottom", "-1px");
            }
        }

        startY = 0, deltaY = 0, currentY = 0, initialBottom = 0, isDragging = false;
    });

};

/**
 * @function
 * @description - Handles fail case of ajax calls
 * @param {Object} error - Returned error object
 * @param {Object} modal - Triggered modal container
 */
const handleModalFail = (error, modal) => {
    console.error(error.responseJSON.error.errorText);
    setTimeout(() => {
        $(modal).modal("hide");
    }, 500);
};

module.exports = {
    modalToggleArrow: modalToggleArrow,
    handleBodyScroll: handleBodyScroll,
    initOnShow: initOnShow
};
